"use strict";
var appn;
(function (appn) {
    var designerv2;
    (function (designerv2) {
        var propertyPane;
        (function (propertyPane) {
            const SECTOR_STATE_KEY = 'appn.designerPropsState';
            let _activeEditors = {};
            const _containers = new Map();
            let _$defaultContainer;
            let _currentComponentId = null;
            let _canSave = true;
            let _sectorDefs;
            let _lastSelection = null;
            let componentSelectionSubscriptionToken;
            let propertyUpdateSubscriptionToken;
            function init(defaultContainerSelector, canSave = true) {
                _$defaultContainer = $(defaultContainerSelector);
                _containers.set(defaultContainerSelector, _$defaultContainer);
                _canSave = canSave;
                designerv2.editors.registerDefaults();
                if (componentSelectionSubscriptionToken)
                    designerv2.eventBus.unsubscribe(componentSelectionSubscriptionToken);
                if (propertyUpdateSubscriptionToken)
                    designerv2.eventBus.unsubscribe(propertyUpdateSubscriptionToken);
                componentSelectionSubscriptionToken = designerv2.eventBus.subscribe(designerv2.EVENTS.COMPONENT_SELECTED, (payload) => handleComponentSelection(payload.componentId, payload === null || payload === void 0 ? void 0 : payload.onlySector));
                propertyUpdateSubscriptionToken = designerv2.eventBus.subscribeToPropertyUpdates(payload => {
                    if (payload.componentId !== _currentComponentId)
                        return;
                    const component = designerv2.designer.getComponent(_currentComponentId);
                    if (component)
                        toggleEditors(component);
                });
            }
            propertyPane.init = init;
            function getSectorState() {
                return appn.localStorage.getItem(SECTOR_STATE_KEY) || {};
            }
            function saveSectorState(sectorId, state) {
                const states = getSectorState();
                states[sectorId] = state;
                appn.localStorage.setItem(SECTOR_STATE_KEY, states);
            }
            function handleComponentSelection(componentId, onlySector) {
                if (typeof appn.popover !== 'undefined' && typeof appn.popover.dismissAll === 'function') {
                    appn.popover.dismissAll();
                }
                const componentAlreadyShowing = componentId !== null && (_lastSelection === null || _lastSelection === void 0 ? void 0 : _lastSelection.componentId) === componentId && (_lastSelection === null || _lastSelection === void 0 ? void 0 : _lastSelection.onlySector) === onlySector;
                _lastSelection = componentId ? { componentId, onlySector } : null;
                if (_currentComponentId === componentId && (!onlySector || onlySector.length == 0))
                    return;
                _currentComponentId = componentId;
                const component = designerv2.designer.getComponent(componentId);
                if (!component) {
                    showEmptyMessage();
                    return;
                }
                if (componentAlreadyShowing) {
                    toggleEditors(component);
                    return;
                }
                buildPaneForComponent(component, onlySector);
                toggleEditors(component);
            }
            function sortBySector(properties) {
                const entries = Object.entries(properties);
                let sectorOrder = _sectorDefs.map(sector => sector.id);
                entries.sort(([, defA], [, defB]) => {
                    const indexA = sectorOrder.indexOf(defA.sector);
                    const indexB = sectorOrder.indexOf(defB.sector);
                    if (indexA !== -1 && indexB !== -1) {
                        return indexA - indexB;
                    }
                    if (indexA !== -1)
                        return -1;
                    if (indexB !== -1)
                        return 1;
                    return defA.sector.localeCompare(defB.sector);
                });
                return Object.fromEntries(entries);
            }
            function buildPaneForComponent(component, onlySector) {
                var _a, _b;
                clearPane();
                const definition = designerv2.componentManager.getDefinition(component.type);
                if (!definition)
                    return;
                if (!_sectorDefs)
                    _sectorDefs = designerv2.componentManager.getSectors();
                const sectors = {};
                const sortedProps = (_b = (_a = definition.sortProperties) === null || _a === void 0 ? void 0 : _a.call(definition)) !== null && _b !== void 0 ? _b : sortBySector(definition.properties);
                for (const propName in sortedProps) {
                    const propDef = definition.properties[propName];
                    const sectorDef = _sectorDefs.find(def => def.id === propDef.sector);
                    if (!sectorDef)
                        throw new Error(`Sector ${propDef.sector} has not been registered with componentManager`);
                    if (!sectors[propDef.sector]) {
                        const $sectorEl = $(`
                    <li class="sector ${sectorDef.id}">
                        <div class="propSectionTitle card-header">
                            <h3 class="card-title toggle">
                                <i class="fa ${sectorDef.icon}"></i> ${T(sectorDef.label)}</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool btnToggleVisibility"><i class="fa fa-chevron-circle-up"></i></button>
                                </div>
                        </div>
                        <ul class="toggleContainer list-unstyled" />
                    </li>`);
                        sectors[propDef.sector] = $sectorEl.find('.toggleContainer');
                        if (propDef.container) {
                            if (!_containers.has(propDef.container))
                                _containers.set(propDef.container, $(propDef.container));
                            _containers.get(propDef.container).append($sectorEl);
                        }
                        else
                            _$defaultContainer.append($sectorEl);
                        const ignoreSaveState = onlySector && onlySector.length > 0;
                        const $sectorHeader = $sectorEl.find('.propSectionTitle');
                        const $toggleIcon = $sectorEl.find('.btnToggleVisibility i');
                        const $sectorContainer = $sectorEl.find('.toggleContainer');
                        const headerId = `sector-head-${propDef.sector}`;
                        $sectorHeader.prop('id', headerId);
                        $sectorHeader.on('click', (event) => {
                            event.preventDefault();
                            const $sector = $(event.currentTarget).closest('.sector');
                            if ($sector.hasClass('sector-collapsed')) {
                                $sector.removeClass('sector-collapsed');
                                $sectorContainer.slideDown(200);
                                $toggleIcon.removeClass('fa-chevron-circle-down').addClass('fa-chevron-circle-up');
                                if (!ignoreSaveState)
                                    saveSectorState(headerId, 'expanded');
                            }
                            else {
                                $sector.addClass('sector-collapsed');
                                $sectorContainer.slideUp(200);
                                $toggleIcon.removeClass('fa-chevron-circle-up').addClass('fa-chevron-circle-down');
                                if (!ignoreSaveState)
                                    saveSectorState(headerId, 'collapsed');
                            }
                        });
                        if (ignoreSaveState && propDef.sector !== onlySector)
                            $sectorHeader.trigger('click');
                        else {
                            const savedStates = getSectorState();
                            if (savedStates[headerId] === 'collapsed')
                                $sectorHeader.trigger('click');
                        }
                    }
                    const propListItem = $('<li>').attr('data-prop', propName);
                    sectors[propDef.sector].append(propListItem);
                    const editor = designerv2.editors.createAndAttach(propListItem, component, propName, propDef, _canSave);
                    if (editor)
                        _activeEditors[propName] = editor;
                }
            }
            function toggleEditors(component) {
                const defn = designerv2.componentManager.getDefinition(component.type);
                if (defn === null || defn === void 0 ? void 0 : defn.toggleEditors)
                    defn.toggleEditors(component, _activeEditors);
                Object.values(_activeEditors).forEach(editor => {
                    if (editor.propDef.visibleWhen) {
                        const shouldShow = editor.propDef.visibleWhen(component);
                        editor.setVisibility(shouldShow);
                    }
                });
            }
            function clearPane() {
                Object.values(_activeEditors).forEach(editor => editor.destroy());
                _activeEditors = {};
                _containers.forEach($container => {
                    $container.empty();
                });
            }
            function showEmptyMessage() {
                clearPane();
                _$defaultContainer.append(`<li class="emptyData"><i class="fa fa-hand-point-left"></i> ${T('Select an item to see its properties.')}</li>`);
            }
        })(propertyPane = designerv2.propertyPane || (designerv2.propertyPane = {}));
    })(designerv2 = appn.designerv2 || (appn.designerv2 = {}));
})(appn || (appn = {}));
